import { render, staticRenderFns } from "./PublicationContent.vue?vue&type=template&id=3340fd6a"
import script from "./PublicationContent.vue?vue&type=script&lang=js"
export * from "./PublicationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports